import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  query BlogUrlExtractedDescription($id: ID!) {
    blogUrlExtractedDescription(id: $id) {
      extractionErrors
      status
      description
    }
  }
`;

interface Result {
  extractionErrors?: string[];
  status?: string;
  description?: string;
}

export const queryBlogUrlExtractedDescription = async (id: ID) => {
  const variables = { id };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
